export const highPriceIndicator = H => {
  var addEvent = H.addEvent,
    merge = H.merge

  addEvent(H.Series, 'afterRender', function () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const serie = this
    const seriesOptions = serie.options
    const lastPrice = seriesOptions.lastPrice

    if (lastPrice && seriesOptions.id !== 'highcharts-navigator-series') {
      const yAxis = serie.yAxis
      const origOptions = yAxis.crosshair
      const origGraphic = yAxis.cross
      const origLabel = yAxis.crossLabel
      const points = serie.points

      const lastPoint = points[points.length - 1]

      if (lastPrice && lastPrice.enabled && lastPoint) {
        yAxis.crosshair = yAxis.options.crosshair = merge(
          {},
          seriesOptions.lastPrice
        )

        yAxis.cross = serie.lastPrice

        if (serie.crossLabel) {
          serie.crossLabel.destroy()
        }

        // Save price
        yAxis.drawCrosshair(null, lastPoint)

        if (yAxis.cross) {
          serie.lastPrice = yAxis.cross
          serie.lastPrice.y = lastPoint.y
        }

        serie.crossLabel = yAxis.crossLabel
      }

      // Restore crosshair:
      yAxis.crosshair = origOptions
      yAxis.cross = origGraphic
      yAxis.crossLabel = origLabel
    }
  })
}
